import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * EmptyState — zero-data / no-results placeholder.
 *
 * Use for empty lists, no-search-results, no-permissions, and
 * similar "there's nothing here yet" states. Pair with a single
 * primary action so the user has a clear next step.
 *
 * @example
 *   <EmptyState
 *     icon={<PlusIcon />}
 *     title="No projects yet"
 *     description="Create your first project to get started."
 *     action={<Button onClick={openCreate}>New project</Button>}
 *   />
 */
export function EmptyState({ title, description, icon, action, secondaryAction, }) {
    return (_jsxs("div", { className: "osd-empty-state", role: "status", children: [icon !== undefined && _jsx("div", { className: "osd-empty-state__icon", children: icon }), title !== undefined && _jsx("div", { className: "osd-empty-state__title", children: title }), description !== undefined && (_jsx("div", { className: "osd-empty-state__description", children: description })), (action !== undefined || secondaryAction !== undefined) && (_jsxs("div", { className: "osd-empty-state__actions", children: [action, secondaryAction] }))] }));
}
//# sourceMappingURL=EmptyState.js.map